import { render, staticRenderFns } from "./NormalSearchNav180.vue?vue&type=template&id=455ed2b2&scoped=true&"
import script from "./NormalSearchNav180.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav180.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455ed2b2",
  null
  
)

export default component.exports